module.exports = __webpack_public_path__ + "assets/img/icon64_appwx_logo.6831446c.png";